import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ModalDialog } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FileUploader } from "react-drag-drop-files";
import Dragable from 'react-draggable';
import { MultiSelect } from "react-multi-select-component";
import ReactTimePicker from 'react-time-picker';
import { CommonApiData, GetSession } from '../../EnvConfig/env_config';
import { autoCompleteDelay } from '../../config';
import { FetchAutoCompleteData, FileUploadChild, FindTranslatedKey } from './CustomHooks';
export const FormButton = (props) => {

    let { handleSubmit, handleExport, handleClear, handleGenerate, id = null, inputrefs, children, save = true, Export = true, update = false, Search = false, generate = false, Print = false, handlePrint,
        Reset = true, saveicon = null, savetext = 'Save' } = props
    return (
        <div className='d-block d-md-flex' >
            <div className="">

                {save ?
                    <button type="button" name={id}
                        ref={ref => (inputrefs ? inputrefs.current[id] = ref : null)}
                        onClick={handleSubmit}
                        className="btn btn-rounded btn-success">
                        <span className=" text-white me-2">
                            {saveicon ? <i className={saveicon}></i> : <i className="fa">&#xf0c7;</i>}
                        </span>{FindTranslatedKey(`${savetext}`)}</button>
                    : <></>}
                {generate ?
                    <button type="button" name={id} ref={ref => (inputrefs ? inputrefs.current[id] = ref : null)}
                        onClick={handleGenerate} className="btn btn-rounded btn-success"><span className="text-white me-2">
                            <i className="fa-solid fa-pen-to-square text-white color-success"></i>
                        </span>{FindTranslatedKey('Generate')}</button> : <></>}
                {Search ?
                    <button type="button" name={id}
                        ref={ref => (inputrefs ? inputrefs.current[id] = ref : null)}
                        onClick={handleSubmit}
                        className="btn btn-rounded btn-success">
                        <span className=" text-white me-2">
                            <i className="fa fa-search text-white color-success"></i>
                        </span>{FindTranslatedKey('Search')}</button>
                    : <></>}

                {Export ?
                    <button type="button" className="btn btn-rounded btn-warning" name={id}
                        onClick={handleExport}
                    ><span className=" text-warning me-2"><i className="fa fa-download text-white color-success"></i>
                        </span>{FindTranslatedKey('Export')}</button>
                    : <></>}
                {update ?
                    <button type="button" name={id}
                        ref={ref => (inputrefs ? inputrefs.current[id] = ref : null)}
                        onClick={handleSubmit}
                        className="btn btn-rounded btn-success">
                        <span className=" text-white me-2">
                            <i class="fa-solid fa-pen-to-square"></i>
                        </span>{FindTranslatedKey('Update')}</button>
                    : <></>}
                {Reset ?
                    <button type="button" name={id} onClick={handleClear} className="btn btn-rounded btn-danger"><span className="text-white me-2">
                        <i className="fa-solid fa-arrow-rotate-left"></i>
                    </span>{FindTranslatedKey('Reset')}</button> : <></>}

                {Print ?
                    <button type="button" name={id} onClick={handlePrint} className="btn btn-rounded btn-warning"><span className="text-white me-2">
                        <i className="fa-solid fa-print"></i>
                    </span>{FindTranslatedKey('Bill Print')}</button> : <></>}


                {children}
            </div>
        </div>
    )
}

export const ImportButtonOld = ({ BulkSubmit, handleBulk, downloadFormat, children, Status = [], ErrorData, fileName = '' }) => {
    return (
        <div className='p-2 w-100' style={{ 'borderRadius': '8px', border: '1px dashed var(--border-color)' }}>
            <label className="form-label">{FindTranslatedKey('Bulk Upload')}
                {/*  <span style={{ color: "red" }}> *</span>*/}
            </label>
            <FileUploader classes='file-uploader bulk-upload'
                handleChange={BulkSubmit}
                types={["xlsx"]}
                children={<FileUploadChild label='' message={fileName} types={["xlsx"]} />}
            />
            <div className='mt-2'>
                <button type="button" className="btn btn-rounded btn-primary me-3 mb-0" style={{ minWidth: '8px' }} onClick={handleBulk}>
                    <i className="fa fa-upload text-white color-success"></i>{FindTranslatedKey('Upload')}
                </button>
                <span type="button" style={{ minWidth: '8px', textDecoration: 'underline', color: 'var(--blue)', fontSize: '13px' }} onClick={downloadFormat}>
                    {FindTranslatedKey('Download Format')} <i className="fa fa-download color-success"></i>
                </span>
            </div>
            <div className='d-flex mb-1'>
                {Status?.length !== 0 ?
                    <>
                        <div className='text-success p-0 pt-2 m-0 fw-bold' style={{ lineHeight: '14px' }}>Success : {Status?.SuccessCount} &nbsp; &nbsp;
                            <span className='text-danger'>Error : {Status?.ErrorCount}
                                {Status?.length !== 0 && Status?.ErrorData?.length !== 0 ?
                                    <>&nbsp;<i className="fa fa-download  color-success" style={{ cursor: 'pointer' }} onClick={ErrorData}></i></>
                                    : ""}
                            </span></div>
                    </>
                    : ""}
            </div>
            {children}
        </div>
    )
}

export const ImportButton = ({ BulkSubmit, handleBulk, downloadFormat, children, Status = [], ErrorData, fileName = '', handleClear, clear = false, showDelete = false, handleBulkDelete }) => {
    return (
        <div className='p-2 w-100' style={{ 'borderRadius': '8px', border: '1px dashed #DABE6D' }}>
            <label className="form-label">{'Bulk Upload'}
                {/*  <span style={{ color: "red" }}> *</span>*/}
            </label>
            <FileUploader classes='file-uploader bulk-upload'
                handleChange={BulkSubmit}
                types={["xlsx"]}
                children={<FileUploadChild label='' message={fileName} types={["xlsx"]} />}
            />
            <div className='mt-2'>
                <button type="button" className="btn btn-rounded btn-warning me-3 mb-0" style={{ minWidth: '8px' }} onClick={handleBulk}>
                    <i className="fa fa-upload text-white" style={{ color: '#DABE6D' }}></i> Upload
                </button>
                {showDelete && <button type="button" className="btn btn-rounded btn-danger me-3 mb-0" style={{ minWidth: '8px' }} onClick={handleBulkDelete}>
                    <i className="fa fa-trash text-white color-success"></i> Delete
                </button>}
                {clear &&
                    <button type="button" className="btn btn-rounded btn-danger me-3 mb-0" style={{ minWidth: '8px' }} onClick={handleClear}>
                        <i className="fa fa-clear text-white color-success"></i> Clear
                    </button>}
                <span type="button" style={{ minWidth: '8px', textDecoration: 'underline', color: '#DABE6D', fontSize: '13px' }} onClick={downloadFormat}>
                    Download Format <i className="fa fa-download" style={{ color: '#DABE6D' }}></i>
                </span>
            </div>
            <div className='d-flex mb-1'>
                {Status?.length !== 0 ?
                    <>
                        <div className='text-success p-0 pt-2 m-0 fw-bold' style={{ lineHeight: '14px' }}>Success : {Status?.SuccessCount} &nbsp; &nbsp;
                            <span className='text-danger'>Error : {Status?.ErrorCount}
                                {Status?.length !== 0 && Status?.ErrorData?.length !== 0 ?
                                    <>&nbsp;<i className="fa fa-download  color-success" style={{ cursor: 'pointer' }} onClick={ErrorData}></i></>
                                    : ""}
                            </span></div>
                    </>
                    : ""}
            </div>
            {children}
        </div>
    )
}

export const InputBox = (props) => {
    let { divclassname = 'col-md-3 mb-1 cntrl-width ', renderinput = null, key = '',
        labelclass = 'form-label', onKeyDown = null, inputclassname = 'form-control', type = 'text',
        divstyle = null, inputstyle = null, inputrefs, id, label = '', value, onChange, onInputChange, PlaceHolderText, required, disabled } = props
    return (
        <div
            className={`${divclassname}`}
            style={divstyle}
            key={key}
        >
            {label !== '' ? <label style={{ 'whiteSpace': 'nowrap' }} className={labelclass} htmlFor={id}>{FindTranslatedKey(label)}
                {required ? <span style={{ color: "red" }}> *</span> : <></>}
            </label> : <></>}
            <input
                id={id}
                style={inputstyle}
                onKeyDown={onKeyDown}
                ref={ref => inputrefs && (inputrefs.current[id] = ref)}
                type={type}
                className={`${inputclassname}`}
                value={value}
                onChange={onChange}
                disabled={disabled}
                placeholder={FindTranslatedKey(PlaceHolderText)}
                autoComplete="off"
                title={required ? FindTranslatedKey('Please fill this field.') : ''}
                {...props}
            />
            {renderinput}


        </div>
    )
}

export const InputBoxWithCheck = (props) => {
    let { divclassname = 'col-md-3 mb-1 cntrl-width ', renderinput = null, key = '', labelclass = 'form-label mb-0', titleInfo = '', onKeyDown = null, inputclassname = 'form-control', type = 'text', divstyle = null, inputstyle = null, inputrefs, id, label = '', value, onChange, placeholder, required, extraElement } = props
    return (
        <div
            className={`${divclassname}`}
            style={divstyle}
            key={key}
        >
            {label !== '' ? <label style={{ 'whiteSpace': 'nowrap' }} className={labelclass} htmlFor={id}>{label}
                {required ? <span style={{ color: "red" }}> *</span> : <></>}
                {titleInfo && <i class="fa-solid fa-check"></i>}
                {extraElement && extraElement}
            </label> : <></>}
            <input
                id={id}
                style={inputstyle}
                onKeyDown={onKeyDown}
                ref={ref => (inputrefs.current[id] = ref)}
                type={type}
                className={`${inputclassname}`}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                autoComplete="off"
                title={required ? 'Please fill this field.' : ''}
                {...props}
            />
            {renderinput}


        </div>
    )
}

export const AutoCompleteBox = (props) => {
    const { setOptions, ...restProps } = props;

    const { divclassname = 'col-md-3 mb-1 cntrl-width', onKeyPress, onKeyDown, style, divstyle,
        inputstyle, inputrefs, maxLength, id, label = '', options, inputValue, onInputChange, placeholder, required } = restProps

    return (
        <div
            className={`${divclassname}`}
            style={style || divstyle}
        >
            {label === '' ? '' :
                <label className="form-label" htmlFor={id}>{FindTranslatedKey(label || '')}
                    {required ? <span style={{ color: "red" }}> *</span> : <></>}
                </label>
            }
            <Autocomplete
                inputValue={inputValue}
                onInputChange={onInputChange}
                freeSolo
                filterOptions={(x) => x}
                options={options ? options.map(ele => FindTranslatedKey(ele)) : []}
                onClose={(event, reason) => {
                    if (setOptions) {
                        setOptions([]);
                    }
                }}
                autoHighlight={true}
                selectOnFocus={true}
                title={required ? FindTranslatedKey('Please fill this field.') : ''}
                renderInput={(params) => <TextField
                    {...params}
                    onInput={(e) => {
                        const { value } = e.target;

                        if (value.length > maxLength) {
                            e.target.value = value.slice(0, maxLength);
                        }
                    }}
                    //inputProps={{ ref: ref => (inputrefs.current[id] = ref) }}
                    inputRef={ref => (inputrefs.current[id] = ref)}
                    sx={inputstyle}
                    placeholder={FindTranslatedKey(placeholder)}
                    //ref={ref => (inputrefs.current[id] = ref)}
                    onKeyPress={onKeyPress}
                    onKeyDown={onKeyDown}
                    autoComplete="off"
                />
                }
                {...restProps}



            />
        </div>
    )
}

export const AutoCompleteBoxNew = (props) => {
    const { divclassname = 'col-md-3 mb-1 cntrl-width', onKeyDown, style, divstyle, inputstyle, inputrefs, maxLength, label = '', nextFocus = ''
        , placeholder, required, value, autocompleteType = '', contextKey = '', contextKey2 = '', contextKey3 = '', contextKey4 = '', contextKey5 = '', contextKey6 = '', renderinput = null,
        Options, isLocalOption = false, rendersublabel = null, issublabel = false, disabled = false, inputType = 'text', ...restProps } = props;

    const { id, multiple = false } = restProps

    const autoCompleteTimeoutRef = useRef(null);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [inputValue, setInputValue] = useState(value);
    useEffect(() => {
        setInputValue(value);
    }, [value]);

    // const commonData = CommonApiData()
    let Data = {
        "authToken": CommonApiData().AuthToken,
        "token": CommonApiData().Token,
        "LoginUserCode": CommonApiData().LoginUserCode,
        "companyCode": CommonApiData().CompanyCode,
    };
    const handleAutoCompleteChange = (event, prefix) => {
        if (isLocalOption) {
            setAutoCompleteOptions(Options ? Options : []);
        } else {
            if (autoCompleteTimeoutRef.current) {
                clearTimeout(autoCompleteTimeoutRef.current);
            }
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData(Data, prefix, autocompleteType, contextKey, contextKey2, contextKey3, contextKey4, contextKey5, contextKey6);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay);
        }
    };

    const handleKeyDown = (event, currentKey) => { //auto focus on next input
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent form submission
            if (inputrefs && inputrefs.current && inputrefs.current !== undefined) {
                const keys = Object.keys(inputrefs.current);
                const currentIndex = keys.indexOf(currentKey);
                const nextIndex = (currentIndex + 1) % keys.length;
                let nextKey = keys[nextIndex];
                if (nextFocus && nextFocus !== "" && nextFocus !== undefined) {
                    nextKey = nextFocus;
                }
                if (inputrefs.current[nextKey]) {
                    inputrefs.current[nextKey].focus();
                }
            }
        }
    };

    return (
        <>
            <div
                className={`${divclassname}`}
                style={style || divstyle}
            >
                {label === '' ? '' :
                    <label className="form-label" htmlFor={id}>{label || ''}
                        {required ? <span style={{ color: "red" }}> *</span> : <></>}
                    </label>
                }
                <Autocomplete
                    value={inputValue}
                    freeSolo
                    multiple={multiple}
                    autoComplete
                    autoSelect
                    disabled={disabled}
                    autoHighlight={true}
                    selectOnFocus={true}
                    includeInputInList
                    filterOptions={(x) => x}
                    options={autoCompleteOptions}
                    isOptionEqualToValue={(option, value) => multiple && option === value}
                    onInputChange={(event, newInputValue, reason) => {
                        if (reason && newInputValue && reason === 'input') {
                            handleAutoCompleteChange(event, newInputValue);
                        } else {
                            if (autoCompleteOptions) {
                                setAutoCompleteOptions([]);
                            }
                        }
                    }}
                    onClose={(event, reason) => {
                        if (autoCompleteOptions) {
                            setAutoCompleteOptions([]);
                        }
                    }}
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => {
                            const tagProps = getTagProps({ index });
                            return (
                                <Chip
                                    key={index}
                                    label={option}
                                    {...tagProps}
                                    onClick={(event) => {
                                        if (typeof tagProps.onClick === 'function') {
                                            tagProps.onClick(event);
                                        }
                                        //  console.log('Chip clicked:', option);
                                    }}
                                />
                            );
                        })
                    }
                    title={required ? 'Please fill this field.' : ''}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            inputProps={{
                                ...params.inputProps,
                                type: { inputType },
                                onKeyPress: (event) => {
                                    const charCode = event.which ? event.which : event.keyCode;
                                    if (
                                        ((charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) ||
                                            (charCode === 46 && event.target.value.indexOf('.') !== -1)) &&
                                        inputType === 'number'
                                    ) {
                                        event.preventDefault();
                                    }
                                }
                            }}
                            onInput={(e) => {
                                const { value } = e.target;
                                if (value.length > maxLength) {
                                    e.target.value = value.slice(0, maxLength);
                                }
                            }}
                            inputRef={(ref) => (inputrefs.current[id] = ref)}
                            sx={inputstyle}
                            onClick={(event) => {
                                //  console.log('Autocomplete input clicked:', event);
                                params.inputProps?.onClick?.(event);
                            }}
                            placeholder={placeholder}
                            onKeyDown={onKeyDown}
                            autoComplete="off"
                        />
                    )}
                    {...restProps}
                />
                {renderinput}
                {issublabel && <div>{rendersublabel}</div>}
            </div>

        </>
    )
}


export const DateBox = (props) => {
    const { divclassname = 'col-md-3 mb-1 cntrl-width', datepikerclass = '', labelstyle, style, label = '', onKeyDown, selected,
        placeholder, id, inputrefs, onChange, required, preventOpenOnFocus = false } = props
    const validDateInput = function (e) {
        e.target.value = "";
    };
    return (
        <div
            className={`${divclassname}`}
            style={style}
        >
            {label === '' ? '' :
                <label className="form-label" style={labelstyle}>{FindTranslatedKey(label)}
                    {required ? <span style={{ color: "red" }}> *</span> : <></>}

                </label>
            }
            <DatePicker
                className={`form-control input-fields ${datepikerclass}`}
                dateFormat="dd-MMM-yyyy"
                //  placeholderText={placeholder}
                placeholderText={FindTranslatedKey(placeholder)}
                selected={selected}
                ref={ref => (inputrefs.current[id] = ref?.input)}
                onKeyDown={onKeyDown}
                // inputrefs={inputrefs.current[id]}
                //isClearable={true}
                //selectsRange={true}
                //monthsShown={3 }
                // onMonthChange={() => { }}
                showYearDropdown={true}
                showMonthDropdown={true}
                //  selectsStart={true }
                //inline={true }
                //showIcon={true }
                //  autoFocus={true}
                preventOpenOnFocus={preventOpenOnFocus}
                //closeOnScroll={true}
                // showFullMonthYearPicker={true }
                //  showTwoColumnMonthYearPicker={true }
                // onDayMouseEnter
                // focusSelectedMonth={true }
                //todayButton={true }
                yearDropdownItemNumber={50}
                scrollableYearDropdown={true}
                onChangeRaw={(e) => validDateInput(e)}
                onChange={onChange}
                autoComplete="off"
                title={required ? FindTranslatedKey('Please fill this field.') : ''}
                {...props}
            />
        </div>
    )
}

export const SelectInputBox = (props) => {
    const { divclassname = 'col-md-3 mb-1 cntrl-width', inputclassname, onKeyDown, divstyle, inputstyle, inputrefs, id, label = '',
        value, onChange, children, required } = props
    return (
        <div
            className={` ${divclassname}`}
            style={divstyle}
        >
            {label === '' ? '' :
                <label className="form-label" htmlFor={id}>{FindTranslatedKey(label)}
                    {required ? <span style={{ color: "red" }}> *</span> : <></>}
                </label>}
            <select
                id={id}
                className={`form-select ${inputclassname}`}
                style={inputstyle}
                onKeyDown={onKeyDown}
                ref={ref => (inputrefs ? inputrefs.current[id] = ref : '')}
                value={value}
                onChange={onChange}
                title={required ? FindTranslatedKey('Please select an item in the list.') : ''}
                autoComplete="off"
                {...props}
            >
                {children}
            </select>
        </div>
    )
}

export const Switch = (props) => {
    const { id, checked = false, inputrefs, onKeyDown, label, extraclassname = 'form-check form-switch ps-4  mt-3 me-2', inputClassName = "",
        onChange, divclassname = 'col-md-3 mb-1  cntrl-width' } = props
    return (
        <div className={` ${divclassname}`} key={`checkin${id}`}>
            <div className={`${extraclassname}`} >
                <input
                    className={`form-check-input ${inputClassName}`}
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    ref={ref => (inputrefs && (inputrefs.current[id] = ref))}
                    {...props}
                />
                <label className="form-check-label ms-2" htmlFor={id}>{FindTranslatedKey(label)}</label>
            </div>
        </div>
    )
}
export const Radio = (props) => {
    const { id, checked = false, inputrefs, onKeyDown, label, extraclassname = 'form-check  ps-4  mt-3 me-2',
        onChange, divclassname = 'col-md-3 mb-1  cntrl-width' } = props
    return (
        <div className={` ${divclassname}`} key={`checkin${id}`}>
            <div className={`${extraclassname}`} >
                <input
                    className="form-check-input"
                    type="radio"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    ref={ref => (inputrefs && (inputrefs.current[id] = ref))}
                    {...props}
                />
                <label className="form-check-label ms-2" htmlFor={id}>{FindTranslatedKey(label)}</label>
            </div>
        </div>
    )
}
export const CheckBoxInput = (props) => {
    const { id, checked = false, inputrefs, onKeyDown, label, extraclassname = 'form-check  ps-4  mt-3 me-2',
        onChange, divclassname = 'col-md-3 mb-1  cntrl-width' } = props
    return (
        <div className={` ${divclassname}`} key={`checkin${id}`}>
            <div className={`${extraclassname}`} >
                <input
                    className="form-check-input"
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    ref={ref => (inputrefs && (inputrefs.current[id] = ref))}
                    {...props}
                />
                <label className="form-check-label ms-2" htmlFor={id}>{FindTranslatedKey(label)}</label>
            </div>
        </div>
    )
}
export const CheckboxSideLabel = (props) => {
    const { label, checked, onChange, innerdivclassname = '', labelclassname = '', maindivclassname = 'd-inline-block ms-3', inputclassname = '', id, onKeyDown, onClick, disabled, InfoDetails } = props;
    return (<div className={`${maindivclassname}`}>
        <div className={`${innerdivclassname}`}>
            <input
                className={`me-1 animate-checkbox arrow  ${inputclassname}`}
                id={id}
                disabled={disabled}
                type="checkbox"
                checked={checked}
                onChange={onChange}
                onKeyDown={onKeyDown}
                onClick={onClick}
            />
            {label !== "" && <label className={`text-nowrap ${labelclassname} cursor-pointer`} title={FindTranslatedKey(label)} htmlFor={id}> {FindTranslatedKey(label)} </label>}
        </div>
    </div>
    )

}
//export const CheckBoxInput = (props) => {
//    const { id, checked = false, maindivclassname = 'col-md-4 col-lg-3 col-6 mb-1 cntrl-width',
//        divclassname = `form-check form-switch ps-4 ps-md-5 mt-3`, labelclassname = "form-check-label ms-2", inputrefs, onKeyDown, label = '', onChange } = props
//    return (
//        <div className={maindivclassname} key={`checkin${id}`}>
//            <div className={divclassname}>
//                <input
//                    className=""
//                    type="checkbox"
//                    id={id}
//                    checked={checked}
//                    onChange={onChange}
//                    onKeyDown={onKeyDown}
//                    ref={ref => (inputrefs.current[id] = ref)}
//                    {...props}
//                />
//                {label !== '' && <label className={labelclassname} htmlFor={id}>{label}</label>}
//            </div>
//        </div>
//    )
//}

export const MessageBoxAlert = React.memo(({ Msg = '', clearMessage, Status, uniqueId }) => {
    const audio = useMemo(() => new Audio(Status !== 'SUCCESS' ? './Sound/Error.mp3' : './Sound/Success.mp3'), [Status]);

    const handleClearMessage = useCallback(() => {
        clearMessage();
    }, [clearMessage]);
    let enableNotificationSound = false;
    if (GetSession('localStorage', 'enableNotificationSound') === 'true') {
        enableNotificationSound = true;
    }
    else if (GetSession('localStorage', 'enableNotificationSound') === null) {
        enableNotificationSound = true;
    }
    if (Msg !== '' && uniqueId) {
        if (enableNotificationSound) {

            audio.play();
        }
    }

    return (
        <>
            {Msg === '' ? '' :
                <div className='container-fluid p-0 m-0 pt-1 '>
                    <div className='col-md-12 col-lg-12 col-12 px-3 py-2 rounded'
                        style={{ background: Status !== 'SUCCESS' ? '#ff7070' : '#68d95b96', color: '#172b64', fontWeight: '500' }}>
                        {Msg}
                        <span style={{ float: 'right', cursor: 'pointer' }} onClick={handleClearMessage}>X</span>
                    </div>
                </div>
            }
        </>
    );
});

export const TimeBox = (props) => {
    let { divclassname = 'col-md-3 mb-1 cntrl-width ', key = '', hideclock = true, labelclass = 'form-label', inputstyle, onKeyDown = null,
        inputclassname = '', divstyle = null, inputrefs, id, label = '', value, onChange, placeholder, required } = props
    return (
        <div
            className={`${divclassname}`}
            style={divstyle}
        >
            {label !== '' ? <label style={{ 'whiteSpace': 'nowrap' }} className={labelclass} htmlFor={id}>{FindTranslatedKey(label)}
                {required ? <span style={{ color: "red" }}> *</span> : <></>}
            </label> : <></>}
            <div
                ref={ref => (inputrefs.current[id] = (ref?.children[0]?.children[0]?.children[0]?.children[1]))}
                className='TimeBox'
                key={key}
            >
                <ReactTimePicker
                    value={value}
                    style={inputstyle}
                    onChange={onChange}
                    format="HH:mm"
                    clockIcon=''
                    placeholder={placeholder}
                    disableClock={hideclock}
                    autoComplete="off"
                    title={required ? FindTranslatedKey('Please fill this field.') : ''}
                    id={id}
                    onKeyDown={onKeyDown}
                    className={`form-control ${inputclassname}`}
                    {...props}
                />

            </div>
        </div>
    )
}
export default class DragableModal extends React.Component {
    render() {
        return <Dragable handle=".modal-header">
            <ModalDialog {...this.props} />
        </Dragable>
    }
}
export const base64ToBlob = (base64, type = "application/octet-stream") => {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
}


export const MultiSelectInputBox = (props) => {
    const {
        divclassname = "col-md-3 mb-1 cntrl-width",
        name,
        children,
        inputrefs,
        onChange,
        error,
        label,
        onFocus,
        onBlur,
        id,
        inputId,
        divstyle,
        onClick,
        disableSearch = true,
        inputstyle,
        value,
        onKeyDown,
        inputclassname,
        InfoDetails,
        required,
        options,
        labelledBy = 'Select'
    } = props;

    // Assign the ref properly
    const multiSelectRef = useRef(null);

    useEffect(() => {
        if (inputrefs && id && multiSelectRef.current) {
            // Get input if exists
            const inputEl = multiSelectRef.current.querySelector('input');
            if (inputEl) {
                // search input present
                inputrefs.current[id] = inputEl;
            } else {
                // search disabled → focus will simulate click to open dropdown
                inputrefs.current[id] = {
                    focus: () => {
                        const dropdownTrigger = multiSelectRef.current.querySelector('.dropdown-heading');
                        if (dropdownTrigger) dropdownTrigger.click();
                    }
                };
            }
        }
    }, [inputrefs, id, disableSearch]);

    return (
        <div className={`fields ${divclassname}`} id={id} style={divstyle}
            ref={multiSelectRef}>
            {label !== "" && label && (
                <label
                    className={`form-label text-nowrap`}
                    title={label}
                    style={{ color: 'var(--text)', fontWeight: '400' }}
                >
                    {label} {required && <span className="text-danger">*</span>}
                </label>
            )}
            <MultiSelect
                className={`mulitSelect custom-height`}
                inputId={inputId || id}
                options={options}
                value={value}
                onChange={onChange}
                labelledBy={labelledBy}
                disableSearch={disableSearch}
                onKeyDown={onKeyDown}
            />
            {error && value?.trim() === "" && <div className="error-msg">{error}</div>}
        </div>
    );
};